import { FC, createContext, useCallback, useContext, useState } from 'react'
import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryState,
} from '_metronic/helpers'
import { SncrBlocosFiltros } from '../../core/_models'

/** A empresa de vínculo vai em `params` (define a rota `/sncr/{idEmpresa}/blocos`), não em `search`. */
const initialState: QueryState<SncrBlocosFiltros> = {
  ...initialQueryState,
  sort: 'dataRetirada',
  order: 'desc',
  params: {},
}

const QueryRequestContext = createContext<QueryRequestContextProps<SncrBlocosFiltros>>({
  state: initialState,
  updateState: () => {},
})

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState<SncrBlocosFiltros>>(initialState)

  const updateState = useCallback(
    (updates: Partial<QueryState<SncrBlocosFiltros>>) =>
      setState((prev) => ({ ...prev, ...updates })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
